import { apiQuery } from "utils/queries";
import { api } from "./restUtil";
import moment from "moment-timezone";

export const NotificationTaskType = {
  FEEDBACK: "feedback-task",
  PLAN: "plan-task",
} as const;

export type Task = {
  due_date: string;
  scheduled: string;
  type: string;
  session?: {
    id: string;
    scheduled: string;
    user: {
      id: string;
      first_name: string | null;
      last_name: string | null;
    };
  };
  user?: {
    id: string;
    first_name: string | null;
    last_name: string | null;
  };
};

// Both feed the header's badge, so a body the server truncates or renders empty
// has to fail loudly rather than reach the badge as undefined.
export const tasksCountQuery = apiQuery<number>({
  key: "/tasks/count",
  queryFn: async ({ key }) => {
    const resp = await api.get<{ count?: number }>(key);
    if (resp.count === undefined) {
      throw new Error("Malformed /tasks/count response");
    }
    return resp.count;
  },
});

export const tasksQuery = apiQuery<{ list: Task[] }>({
  key: "/tasks",
  queryFn: async ({ key }) => {
    const resp = await api.get<{ list?: Task[] }>(key);
    if (!resp.list) {
      throw new Error("Malformed /tasks response");
    }
    return { list: resp.list };
  },
});

export function isTaskOverdue(task: Task) {
  return moment.utc().isAfter(task.due_date);
}
